export class ChartReport{
    data: Data;
    description:string;
    filters: any;
    name: string;
    priority: number;
    reportID: number;
    reportType: string;
    series: any;
    title: string;
    width: number;
    labels: Array<string>;
    values: Array<string>;
    chartColors: Array<string>;
    chartData: Array<any>;
    chartType: string;
    constructor(){
        this.labels = [];
        this.values = [];
    }
}

class Data {
    RowNumber : number;
    name : string;
    value : any;
}

export class Report{
    id: number;
    name: string;
    description: string;
    title: string;
    reportTypeID: number;
    query: string;
    reportGroup: string;
    prority: number;
    maxRows: number;
    isMobile: boolean;
    columnDefinitions: Array<ColumnDefinition>;
    filterColumns: Array<FilterColumn>;
    columnDefinitionsStr: string;
    filterColumnsStr: string;
    reportType: ReportType;
    isActive: boolean;
    checked: boolean;
}

export class ReportType{
    id: number;
    name: string;
    reportTypeCode: string;
    reports: Report[];
    isExpanded: boolean;
    
}
export class ReportRole{
    reportID: number;
    roleID: number;
    report: Report;
    id: number;
}

export class ColumnDefinition{
    columnIndex : number;
    fieldName: string;
    title: string;
    isVisible : boolean;
    isSortable : boolean;
    dataType: string;
    dDataType: DataType;
    constructor(){
        this.dDataType = new DataType();
        this.isVisible = false;
        this.isSortable = false;
    }
}

export class DataType {
    id : number;
    name : string;   
}

export class FilterColumn{
    alias: string;
    title: string;
    fieldName: string;
    overridingFieldName: string;
    parameterName: string;
    isInnerFilter: boolean;
    dType: DataType;
    type: string;
    query: string;
    constructor(){
        this.dType = new DataType();
        this.isInnerFilter = false;
        this.alias = null;
        this.overridingFieldName = null;
        this.parameterName = null;
        this.query = null;
    }
}

export class TabularReport {
    report: Report;
    filters: Array<Filter>;
    data: Array<any>;
}

export class Filter  {
    type: string;
    fieldName: string;
    title: string;
    value: string;
    query: string;
    isInnerFilter: boolean;
    alias: string;
    overridingFieldName: string;
    parameterName: string;
    data: Array<any>;
    displayValue: string;
    objectValue: any;
}